import { EntityInput, LinkProps } from "helpers/url";

export function pharmacyHref(entity): LinkProps["href"] {
  return {
    pathname: "/pharmacies/pharmacy/[id]",
    query: {
      id: entity.id,
    },
  };
}

export function pharmacyAs(entity: EntityInput): LinkProps["as"] {
  // на беке есть кривые id-ки такого вида 13456.0000000000000000
  // поэтому приводим к нормальному виду
  return `/pharmacies/${parseInt(entity.id)}/`;
}
